import React, { useContext } from 'react'
import { marginSizes } from '@jarvis.oddle/core/theme/default'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import Div from '@jarvis.oddle/core/components/Div'
import {
  InlineNotification,
  notificationStates
} from '@jarvis.oddle/core/components/InlineNotification'
import { Container } from './Elements'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

interface TimeProps {
  onClick: () => void
  formatFullDate: (date: string) => string
  storeOrder: {
    data: Oms.V4.StoreOrder
  }
}

const Time = ({
  onClick,
  formatFullDate,
  storeOrder
}: TimeProps): JSX.Element => {
  const { isPickup, collectionDate, collectionTime } = storeOrder.data
  const { t } = useContext(TranslationContext)
  return (
    <Container data-testid='collectionDetails.time' onClick={onClick}>
      {(!collectionDate || !collectionTime) && (
        <Div width='100%' marginRight={marginSizes.medium}>
          <InlineNotification
            lightTheme
            state={notificationStates.warning}
            text={
              isPickup
                ? t('Please select a pickup time')
                : t('Please select a delivery time')
            }
          />
        </Div>
      )}
      {collectionDate && collectionTime && (
        <Div>
          <H4 normalised bold>
            {isPickup ? t('Pickup Time') : t('Delivery Time')}
          </H4>
          <H4 normalised>
            {t('_day_', { day: formatFullDate(collectionDate) })}
          </H4>
          <H4 normalised>{collectionTime}</H4>
        </Div>
      )}
    </Container>
  )
}

export default Time
